import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Platform, ToastController } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { NAME_PATTERN, PASSWORD_PATTERN } from 'src/app/services/customFormValidators';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { birthdayValidator } from 'src/app/services/customFormValidators';
import { isUndefined } from 'src/app/services/codeUtils';
@Component({
  selector: 'app-boyd-rewards-connect',
  templateUrl: './boyd-rewards-connect.component.html',
  styleUrls: ['./boyd-rewards-connect.component.scss'],
})
export class BoydRewardsConnectComponent implements OnInit {
  @Input() connectBoydCardPath: boolean;
  @Input() navigateBackPage;
  @Input() callBackFn;

  public boydNumber: AbstractControl;
  public lastName:AbstractControl;
  public dob: AbstractControl;
  public infoForm: FormGroup;
  public error = null;
  public csrf: string = '';
  boydRewardsURL: string;
  today:string;
  maxDate:string;
  minDate:string;
  public legalAge: number;
  public buttonDisabled: boolean = false;
  public dateOfBirthGroup: AbstractControl;
  public dateOfBirthYear: AbstractControl;
  public dateOfBirthDay: AbstractControl;
  public dateOfBirthMonth: AbstractControl;
  nextBtnText:string;

  constructor(private successMessageService:SuccessMessageService,
      private boydRewardsService:BoydRewardsService,
      private utils:UtilsService,
      private navigator: Navigator,
      private config:ConfigService,
      private authenticationService:AuthenticationService,
      private toastController:ToastController,
      private userSessionService:UserSessionService,
      private platform:Platform
    ) { 
      this.successMessageService.clearMessage();
    }

  ngOnInit() {
    this.nextBtnText = "Next";
    this.legalAge = this.config.getConfig().FEATURE_LEGAL_AGE || 21;
    this.maxDate  = new Date().toJSON().split('T')[0];
    this.boydRewardsURL = this.config.getConfig()["FEATURE_BOYD_REWARDS_URL"] || "https://rewards.boydgaming.com";
    this.infoForm = new FormGroup({
      boydNumber: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(NAME_PATTERN)]),
      // dob: new FormControl('',Validators.required),
      dateOfBirthGroup: new FormGroup(
        {
          dateOfBirthYear: new FormControl('', [Validators.required]),
          dateOfBirthDay: new FormControl('', [Validators.required]),
          dateOfBirthMonth: new FormControl('', [Validators.required]),
          hiddenLegalAge: new FormControl(this.legalAge)
        },
        birthdayValidator
      ),
    }
  );
  this.boydNumber = this.infoForm.get('boydNumber');
  this.lastName = this.infoForm.get('lastName');
  // this.dob = this.infoForm.get('dob');
  this.dateOfBirthGroup = this.infoForm.get('dateOfBirthGroup');
  this.dateOfBirthYear = this.dateOfBirthGroup.get('dateOfBirthYear');
  this.dateOfBirthDay = this.dateOfBirthGroup.get('dateOfBirthDay');
  this.dateOfBirthMonth = this.dateOfBirthGroup.get('dateOfBirthMonth');

  this.today = new Date().toJSON().split('T')[0];


  this.authenticationService.getCsrfToken().subscribe(
    (response) => {
      if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
        this.csrf = response.payload.token;
      }
    }
  );
  }

  get months() {
   
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if(this.platform.is("capacitor")){
      months=['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
    }
    if (this.dateOfBirthYear.value == this.years[0]) {
      let extra = 11 - new Date().getMonth();
      for (extra; extra > 0; extra--) {
        months.pop();
        if (this.dateOfBirthMonth.value == months.length + 1) this.dateOfBirthMonth.setValue(months.length)
      }
    }
    return months;
  }

  get days() {
    let days = Array.apply(null, { length: 31 }).map(Number.call, Number)
    let displayDays = days.map(val => val + 1).map(val => (val < 10) ? "0" + val.toString() : val.toString());
    if (
      this.dateOfBirthYear.value == this.years[0] &&
      this.dateOfBirthMonth.value - 1 == this.months.indexOf(this.months[this.months.length - 1])
    ) {
      let extra = 31 - new Date().getDate();
      for (extra; extra > 0; extra--) {
        displayDays.pop();
        if (this.dateOfBirthDay.value == displayDays.length + 1) this.dateOfBirthDay.setValue(displayDays[displayDays.length-1]);
      }
    }
    return displayDays;
  }

  get years() {
    let years = [];
    var min = new Date().getFullYear() - 100,
      max = new Date().getFullYear() - this.legalAge;
    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years;
  }

  generateCsrfToken() {
    this.authenticationService.getCsrfToken().subscribe(
      (response) => {
        if (!isUndefined(response.payload) && !isUndefined(response.payload.token)) {
          this.csrf = response.payload.token;
        }
      }
    );
  }


  onBack = () => {
    if (this.navigateBackPage) {
      if (this.navigateBackPage == "default") {
        this.navigator.dismissAll();
      } else {
        this.navigator.navigateTo(this.navigateBackPage);
      }
    } else {
      this.navigator.back();
    }
  };

  
  onSubmit(){
    this.successMessageService.clearMessage();
    this.buttonDisabled = true;
    this.error = null;
    if(this.nextBtnText === 'OK'){
      //this.navigator.toLobby();
      if(!!this.callBackFn){
        this.navigator.dismiss();
      } else {
        this.navigator.toLobby();
      }
    }else {
       let month =
      ~~this.infoForm.value.dateOfBirthGroup.dateOfBirthMonth < 10
        ? "0" + this.infoForm.value.dateOfBirthGroup.dateOfBirthMonth
        : this.infoForm.value.dateOfBirthGroup.dateOfBirthMonth;

    let dob = new Date(
      this.infoForm.value.dateOfBirthGroup.dateOfBirthYear +
        "-" +
        month +
        "-" +
        this.infoForm.value.dateOfBirthGroup.dateOfBirthDay
    );

      let obj:any = {
        clientapp:this.config.getClientApp(),
        csrf: this.csrf,
        reward_number: this.boydNumber.value,
        lastName:this.lastName.value,
        birthDate:dob.toISOString().split("T")[0],
        signup:this.connectBoydCardPath,
        
      }
      if(!this.connectBoydCardPath){
        obj.session_token = this.userSessionService.getSessionToken();
      }
      this.boydRewardsService.callExternalConnect(obj).subscribe({
        next: (response: any) => {
            if (response && !!response.result) {
               
                if(response.payload.sessionToken){
                  this.userSessionService.setSessionToken(response.payload.sessionToken);
                }
                this.boydRewardsService.connectBoydCardToStardust();
                if(this.connectBoydCardPath){
                  this.navigator.navigateTo("SignupStepOneComponent");
                }else {
                  this.successMessageService.setMessage('Your Boyd Rewards account is now connected.');
                  this.boydRewardsService.checkConnectionToBoydCard().subscribe(res => {});
                  this.nextBtnText = "OK";
                  this.buttonDisabled = false;
                  if(!!this.callBackFn){
                    this.navigator.dismiss();
                    this.callBackFn();
                  } else {
                    setTimeout(()=> {
                      this.navigator.toLobby();
                    },5000);
                  }
                  
                }
              
            }else {
              if(!!this.callBackFn){
                this.navigator.dismiss();
                this.callBackFn();
              } 
            }
        },
        error: (error) => {
          this.generateCsrfToken();
            // window.open(this.boydRewardsURL + "/get-connected",'_system');
            this.error = error;
            this.buttonDisabled = false;
            switch (error.getErrorCode().toUpperCase()) {
              case 'CUSTOMER_NOT_FOUND':
                error.setErrorMessage('Customer cannot be found');
                break;
              case 'CARD_ALREADY_EXISTS':
                error.setErrorMessage('Rewards Card already exists');
                break;
              default:
                  error.setErrorMessage('Oops! We cannot confirm your account information');
                  break;
            }
        }
      });
    }
    
  }
  closeModal = () => {
    if (!!this.callBackFn) {
      this.navigator.dismiss();
      this.callBackFn();
    }
    else {
      this.navigator.toLobby();
    }
  }
}
